export default "__VITE_ASSET__45QqLzKc__"